import React from 'react';
import { StyledPaperContainer, StyledSwitch } from '../../PlusWebsiteEditor.styles';
import { StyledContainer, StyledRow, StyledText } from './StatusSection.styled';
import { SetFieldValue } from '../../types/handlers';

type Props = {
  deployed?: boolean;
  onSwitch: SetFieldValue<boolean>;
  enabled?: boolean;
};

const StatusSection = ({ enabled, deployed, onSwitch }: Props) => (
  <StyledPaperContainer>
    <StyledContainer>
      <StyledRow>
        <StyledText>Status:</StyledText>
        <StyledSwitch onChange={(_: any, checked: boolean) => onSwitch('deployed', checked)} value={deployed} checked={deployed} />
        <StyledText isGreen={deployed} isRed={!deployed}>
          {deployed ? 'Deployed' : 'Not Deployed'}
        </StyledText>
      </StyledRow>
      <StyledSwitch onChange={(_: any, checked: boolean) => onSwitch('enabled', checked)} value={!!enabled} checked={!!enabled} label="Allow the organisation's web app to be branded" />
    </StyledContainer>
  </StyledPaperContainer>
);

export default StatusSection;
